/**
 * Обёртка над localStorage: getJSON / setJSON / remove с обработкой ошибок.
 */

const KEY_PREFIX = 'odp_';

function storageAvailable(): boolean {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  try {
    const key = KEY_PREFIX + 'test';
    window.localStorage.setItem(key, '');
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function getJSON<T>(key: string): T | null {
  if (!storageAvailable()) return null;
  try {
    const raw = window.localStorage.getItem(KEY_PREFIX + key);
    if (raw === null) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function setJSON(key: string, value: unknown): boolean {
  if (!storageAvailable()) return false;
  try {
    window.localStorage.setItem(KEY_PREFIX + key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function remove(key: string): boolean {
  if (!storageAvailable()) return false;
  try {
    window.localStorage.removeItem(KEY_PREFIX + key);
    return true;
  } catch {
    return false;
  }
}
